import {BlogPostField} from "../../../types/generated";

export enum ContentType {
    BLOG = "BLOG",
    YOUTUBE_VIDEO = "YOUTUBE_VIDEO",
    SHORT_VIDEO = "SHORT_VIDEO",
}

export const POST_STATUS = {
    DRAFT: "DRAFT",
    READY_TO_PUBLISH: "READY_TO_PUBLISH",
    PUBLISHED: "PUBLISHED",
    UNPUBLISHED: "UNPUBLISHED",
};

export type Post = BlogPostField & {
    id: string;
    author: {
        firstName: string;
    };
    title: string;
    topic: {
        name: string;
    };
    status: typeof POST_STATUS;
    image?: string;
    coverImages: string[];
    body?: string;
    youtubeVideo?: string;
    videoContent?: {
        id: string;
        url: {
            url: string;
        };
    };
};
